module.exports = __webpack_public_path__ + "img/analytics.c836b450.svg";